<!-- Panel para Agencia/Productor: Mostrar anunciantes vinculados -->
@if (isAgenciaOrProductor() && cliente) {
  <p-card class="anunciantes-panel">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between p-4">
        <div>
          <h3 class="text-lg font-semibold m-0" style="color: hsl(var(--text));">
            Anunciantes
          </h3>
          <p class="text-sm m-0 mt-1" style="color: hsl(var(--muted));">
            <span class="font-medium">{{ anunciantes().length }}</span>
            @if (totalAnunciantes() > anunciantes().length) {
              <span> de {{ totalAnunciantes() }}</span>
            }
            <span> vinculado{{ totalAnunciantes() !== 1 ? 's' : '' }}</span>
          </p>
        </div>
      </div>
    </ng-template>

    <div class="flex flex-col gap-3 mb-4">
      <div class="flex gap-2">
        <button 
          pButton 
          type="button"
          label="Vincular"
          icon="pi pi-link"
          class="p-button-outlined p-button-sm flex-1"
          (click)="openLinkDialog()"
          [disabled]="loading()">
        </button>
        <button 
          pButton 
          type="button"
          label="Gestionar"
          icon="pi pi-cog"
          class="p-button-text p-button-sm flex-1"
          (click)="goToAnunciantes()"
          [disabled]="loading()">
        </button>
      </div>
    </div>

    @if (loading()) {
      <div class="text-center py-4">
        <i class="pi pi-spin pi-spinner text-2xl" style="color: hsl(var(--muted));"></i>
      </div>
    } @else if (anunciantes().length > 0) {
      <div 
        class="anunciantes-list"
        (scroll)="onScrollList($event)">
        @for (anunciante of anunciantes(); track anunciante.id) {
          <div class="anunciante-item">
            <div class="flex-1 min-w-0">
              <div class="font-semibold text-sm truncate" style="color: hsl(var(--text));">
                {{ anunciante.razonSocial }}
              </div>
              @if (anunciante.nombreFantasia) {
                <div class="text-xs truncate mt-1" style="color: hsl(var(--muted));">
                  {{ anunciante.nombreFantasia }}
                </div>
              }
            </div>
            @if (anunciante.active) {
              <p-tag value="Activo" severity="success" [rounded]="true" styleClass="text-xs"></p-tag>
            }
          </div>
        }
        @if (loadingMore()) {
          <div class="text-center py-3">
            <i class="pi pi-spin pi-spinner text-lg" style="color: hsl(var(--muted));"></i>
            <p class="text-xs mt-2" style="color: hsl(var(--muted));">Cargando más anunciantes...</p>
          </div>
        }
        @if (hasMore() && !loadingMore()) {
          <div class="text-center pt-2 border-t mt-2">
            <button 
              pButton 
              type="button"
              label="Cargar más"
              icon="pi pi-chevron-down"
              class="p-button-text p-button-sm"
              (click)="loadMoreAnunciantes()"
              [disabled]="loadingMore()">
            </button>
          </div>
        }
        @if (!hasMore() && totalAnunciantes() > 0) {
          <div class="text-center pt-2 border-t mt-2">
            <p class="text-xs mb-2" style="color: hsl(var(--muted));">
              Todos los anunciantes cargados
            </p>
            <button 
              pButton 
              type="button"
              label="Ver página completa"
              icon="pi pi-arrow-right"
              iconPos="right"
              class="p-button-text p-button-sm"
              (click)="goToAnunciantes()">
            </button>
          </div>
        }
      </div>
    } @else {
      <div class="text-center py-6">
        <i class="pi pi-inbox text-3xl mb-2" style="color: hsl(var(--muted));"></i>
        <p class="text-sm mb-3" style="color: hsl(var(--muted));">
          No hay anunciantes vinculados
        </p>
        <button 
          pButton 
          type="button"
          label="Vincular Anunciante"
          icon="pi pi-link"
          class="p-button-sm"
          (click)="openLinkDialog()">
        </button>
      </div>
    }
  </p-card>
}

<!-- Panel para Anunciante: Mostrar agencia/productor padre -->
@if (isAnunciante() && cliente?.agenciaProductor) {
  <p-card class="depende-panel">
    <ng-template pTemplate="header">
      <div class="p-4">
        <h3 class="text-lg font-semibold m-0" style="color: hsl(var(--text));">
          Depende de
        </h3>
      </div>
    </ng-template>
    <div class="depende-content" (click)="goToAgenciaProductor()">
      <div class="flex-1 min-w-0">
        <div class="font-semibold text-sm truncate" style="color: hsl(var(--text));">
          {{ getAgenciaProductorName() }}
        </div>
        <div class="text-xs mt-1" style="color: hsl(var(--muted));">
          Click para ver detalles
        </div>
      </div>
      <i class="pi pi-arrow-right" style="color: hsl(var(--muted));"></i>
    </div>
  </p-card>
}

<!-- Modal: Vincular Anunciante -->
@if (showLinkDialog() && cliente?.id) {
  <app-anunciante-link-dialog
    [visible]="showLinkDialog()"
    [padreId]="getClienteId()"
    (visibleChange)="showLinkDialog.set($event)"
    (anuncianteLinked)="onAnuncianteLinked()">
  </app-anunciante-link-dialog>
}

